import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  // Enlace de catálogo del usuario autenticado
  getMyLink() {
    return axios.get(`${API_URL}/catalog/my-link`, { headers: authHeader() });
  },

  // Catálogo público completo por token (vendedor + productos)
  getCatalogo(token) {
    return axios.get(`${API_URL}/catalogo/${token}`);
  },

  // Variantes (seriales) de un material del catálogo
  getSerials(token, matid) {
    return axios.get(`${API_URL}/catalogo/${token}/material/${matid}/serials`);
  },

  // Configuración pública (logo, TRM)
  getPublicSettings() {
    return axios.get(`${API_URL}/public/settings`);
  },

  // Registra el pedido y devuelve la URL de WhatsApp
  sendPedido(token, payload) {
    return axios.post(`${API_URL}/catalogo/${token}/pedido`, payload);
  },
};
